import React, { useEffect } from "react";
import ProjectView from "@/containers/project-screen/ProjectView";
import { usePath } from "../../contexts/path/path";

const ProjectScreen = ({ setFrozenContext }) => {
  const path = usePath();

  useEffect(() => {
    if (path.unit) return;
    setFrozenContext(path);
  }, [path]);

  return <ProjectView />;
};

export default ProjectScreen;
